import { AxiosResponse } from "axios";
import api from "../api/base-api";

const getNotifications = (data: any): Promise<AxiosResponse> => {
    return api.get(`/notification/developer?read=${data?.read}`);
};

const viewNotification = (ids: any, read: boolean): Promise<AxiosResponse> => {
    return api.post(`/notification/view?read=${read}`, ids);
};

export { getNotifications, viewNotification };
